/**
  * @desc limit the amount of times a function is called to avoid
  *       capturing events every single time they fire
  *
  * @param {function} fn to be called once the events has been fired the last time
  * @param {time} tm delay value
  *
  * @returns {function} method that will be called everytime the debounce method is called
*/

// USAGE
// const debounced = debounce(() => console.log('ciao'), 100);
// window.addEventListener('scroll', debounced);

function debounce(fn, tm = 0) {
  let timeout;

  return (...args) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => fn(...args), tm);
  };
}
export default debounce;
